const showHomeTime = 10;
const perScorePageTime = 10;
const apiUrl = '/api/high-scores';
const PAGE_SIZE = 20;
const COLUMN_SIZE = 10;

function isFullscreen() {
    return Boolean(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
    );
}

function requestFullscreen() {
    const root = document.documentElement;

    if (root.requestFullscreen) {
        return root.requestFullscreen();
    }
    if (root.webkitRequestFullscreen) {
        return root.webkitRequestFullscreen();
    }
    if (root.msRequestFullscreen) {
        return root.msRequestFullscreen();
    }
    return null;
}

function exitFullscreen() {
    if (document.exitFullscreen) {
        return document.exitFullscreen();
    }
    if (document.webkitExitFullscreen) {
        return document.webkitExitFullscreen();
    }
    if (document.msExitFullscreen) {
        return document.msExitFullscreen();
    }
    return null;
}

function updateFullscreenButtonState() {
    const button = document.querySelector('#fullscreen-toggle');
    if (!button) {
        return;
    }

    const expandIcon = button.querySelector('.icon-expand');
    const collapseIcon = button.querySelector('.icon-collapse');
    const fullscreen = isFullscreen();

    button.setAttribute(
        'aria-label',
        fullscreen ? 'Exit fullscreen' : 'Enter fullscreen'
    );
    button.setAttribute(
        'title',
        fullscreen ? 'Exit fullscreen' : 'Enter fullscreen'
    );

    if (expandIcon) {
        expandIcon.classList.toggle('hide', fullscreen);
    }
    if (collapseIcon) {
        collapseIcon.classList.toggle('hide', !fullscreen);
    }
}

function setupFullscreenToggle() {
    const button = document.querySelector('#fullscreen-toggle');
    if (!button) {
        return;
    }

    button.addEventListener('click', function () {
        if (isFullscreen()) {
            exitFullscreen();
            return;
        }
        requestFullscreen();
    });

    document.addEventListener('fullscreenchange', updateFullscreenButtonState);
    document.addEventListener(
        'webkitfullscreenchange',
        updateFullscreenButtonState
    );
    document.addEventListener(
        'MSFullscreenChange',
        updateFullscreenButtonState
    );
    updateFullscreenButtonState();
}

function getPlayerName(score) {
    const name = (score.name || '').trim();
    return name || 'Unknown';
}

function withRanks(scores) {
    let previousScore = null;
    let currentRank = 0;
    let index;
    const ranked = [];

    for (index = 0; index < scores.length; index += 1) {
        const score = scores[index];
        const totalScore =
            Number(score.score != null ? score.score : score.total_score) || 0;
        const rankedScore = {};
        let key;

        if (previousScore === null || totalScore !== previousScore) {
            currentRank = index + 1;
            previousScore = totalScore;
        }

        for (key in score) {
            if (Object.prototype.hasOwnProperty.call(score, key)) {
                rankedScore[key] = score[key];
            }
        }

        rankedScore.rank = currentRank;
        rankedScore.score = totalScore;
        ranked.push(rankedScore);
    }

    return ranked;
}

function chunk(items, size) {
    const pages = [];
    let index;

    for (index = 0; index < items.length; index += size) {
        pages.push(items.slice(index, index + size));
    }

    return pages;
}

function setDataRank(item, value) {
    if (item.dataset) {
        item.dataset.rank = value;
    } else {
        item.setAttribute('data-rank', value);
    }
}

function renderPage(pageScores) {
    const scoreItems = document.querySelectorAll('.score-item');
    const scoreCols = document.querySelectorAll('.scores-col');
    let index;

    for (index = 0; index < scoreItems.length; index += 1) {
        const item = scoreItems[index];
        const score = pageScores[index];
        const rankElement = item.querySelector('.rank');
        const nameElement = item.querySelector('.name');
        const scoreElement = item.querySelector('.score');

        if (!score) {
            item.classList.add('invisible');
            setDataRank(item, '');
            if (rankElement) rankElement.textContent = '';
            if (nameElement) nameElement.textContent = '';
            if (scoreElement) scoreElement.textContent = '';
            continue;
        }

        item.classList.remove('invisible');
        setDataRank(item, String(score.rank));
        if (rankElement) rankElement.textContent = String(score.rank);
        if (nameElement) nameElement.textContent = getPlayerName(score);
        if (scoreElement) scoreElement.textContent = String(score.score);
    }

    for (index = 0; index < scoreCols.length; index += 1) {
        const col = scoreCols[index];
        const colStart = index * COLUMN_SIZE;
        const hasValues =
            pageScores.slice(colStart, colStart + COLUMN_SIZE).length > 0;
        col.classList.toggle('invisible', !hasValues);
    }
}

function showSplashPage() {
    const splash = document.querySelector('#splash');
    const scores = document.querySelector('#scores');

    if (splash) splash.classList.remove('hide');
    if (scores) scores.classList.add('hide');
}

function showScoresPage() {
    const splash = document.querySelector('#splash');
    const scores = document.querySelector('#scores');

    if (splash) splash.classList.add('hide');
    if (scores) scores.classList.remove('hide');
}

function fetchScores(callback) {
    const requestUrl =
        apiUrl + (apiUrl.indexOf('?') === -1 ? '?' : '&') + '_cb=' + Date.now();

    if (!window.fetch) {
        if (!window.XMLHttpRequest) {
            callback(new Error('No supported HTTP client'), []);
            return;
        }

        const xhr = new XMLHttpRequest();
        xhr.open('GET', requestUrl, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                return;
            }

            if (xhr.status < 200 || xhr.status >= 300) {
                callback(
                    new Error('Failed to fetch scores: ' + xhr.status),
                    []
                );
                return;
            }

            try {
                const data = JSON.parse(xhr.responseText);
                if (
                    !data ||
                    !data.success ||
                    !Array.isArray(data.scores) ||
                    data.scores.length === 0
                ) {
                    callback(new Error('Invalid or empty scores payload'), []);
                    return;
                }
                callback(null, data.scores);
            } catch (error) {
                callback(error, []);
            }
        };
        xhr.onerror = function () {
            callback(new Error('Network error'), []);
        };
        xhr.send();
        return;
    }

    window
        .fetch(requestUrl, {
            method: 'GET',
            cache: 'no-store',
        })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Failed to fetch scores: ' + response.status);
            }
            return response.json();
        })
        .then(function (data) {
            if (
                !data ||
                !data.success ||
                !Array.isArray(data.scores) ||
                data.scores.length === 0
            ) {
                callback(new Error('Invalid or empty scores payload'), []);
                return;
            }
            callback(null, data.scores);
        })
        .catch(function (error) {
            callback(error, []);
        });
}

function playScorePages(scores, onComplete) {
    const rankedScores = withRanks(scores);
    const pages = chunk(rankedScores, PAGE_SIZE);
    const safePages = pages.length > 0 ? pages : [[]];
    let pageIndex = 0;

    showScoresPage();
    renderPage(safePages[pageIndex]);

    function nextPage() {
        pageIndex += 1;
        if (pageIndex >= safePages.length) {
            onComplete();
            return;
        }
        renderPage(safePages[pageIndex]);
        window.setTimeout(nextPage, perScorePageTime * 1000);
    }

    window.setTimeout(nextPage, perScorePageTime * 1000);
}

function runCycle() {
    let splashDone = false;
    let fetchDone = false;
    let fetchFailed = false;
    let fetchedScores = [];

    function maybeContinue() {
        if (!splashDone || !fetchDone) {
            return;
        }

        if (fetchFailed) {
            runCycle();
            return;
        }

        playScorePages(fetchedScores, runCycle);
    }

    showSplashPage();

    window.setTimeout(function () {
        splashDone = true;
        maybeContinue();
    }, showHomeTime * 1000);

    fetchScores(function (error, scores) {
        fetchDone = true;
        fetchFailed = Boolean(error);
        fetchedScores = scores || [];
        maybeContinue();
    });
}

/** Unscaled layout size (16:9). Scaled down (or up) to fit the viewport. */
const PAGE_DESIGN_WIDTH = 1920;
const PAGE_DESIGN_HEIGHT = 1080;

function pageScaling() {
    const pageOuter = document.querySelector('#page-outer');
    if (!pageOuter) {
        return;
    }
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const scale = Math.min(
        vw / PAGE_DESIGN_WIDTH,
        vh / PAGE_DESIGN_HEIGHT
    );
    const scaledW = PAGE_DESIGN_WIDTH * scale;
    const scaledH = PAGE_DESIGN_HEIGHT * scale;

    pageOuter.style.position = 'fixed';
    pageOuter.style.left = (vw - scaledW) / 2 + 'px';
    pageOuter.style.top = (vh - scaledH) / 2 + 'px';
    pageOuter.style.width = PAGE_DESIGN_WIDTH + 'px';
    pageOuter.style.height = PAGE_DESIGN_HEIGHT + 'px';
    pageOuter.style.transform = 'scale(' + scale + ')';
    pageOuter.style.transformOrigin = 'top left';
}

document.addEventListener('DOMContentLoaded', function () {
    setupFullscreenToggle();
    runCycle();
    pageScaling();
    window.addEventListener('resize', pageScaling);
});
